// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0

// Credential mutations
export const ERR_ACC_CRED_FREE_OFF = 'Failed to accept free credential offer';
export const ERR_ACC_CRED_PAID_OFF = 'Failed to accept paid credential offer';
export const ERR_BILL_CRED = 'Failed to bill credential';
export const ERR_CAN_BILL_CRED = 'Failed to cancel credential billing';
export const ERR_CAN_CRED_OFF = 'Failed to cancel credential offer';
export const ERR_DIST_CRED_BILL = 'Failed to distribute credential billing';
export const ERR_OFF_CRED_FREE = 'Failed to offer free credential';
export const ERR_OFF_CRED_PAID = 'Failed to offer paid credential';
export const ERR_REJ_CRED_OFF = 'Failed to reject credential offer';
export const ERR_REV_CAN_CRED = 'Failed to revoke credential and cancel billing';
export const ERR_REV_CRED = 'Failed to revoke credential';
export const ERR_TOPUP_CRED_BILL = 'Failed to top up deposit for credential billing';
export const ERR_FLUSH_EXPIRED_CRED_BILL = 'Failed to flush expired deposit for credential billing';
export const SUC_ACC_CRED_FREE_OFF = 'Successfully accepted free credential offer';
export const SUC_ACC_CRED_PAID_OFF = 'Successfully accepted paid credential offer';
export const SUC_BILL_CRED = 'Successfully billed credential';
export const SUC_CAN_BILL_CRED = 'Successfully canceled credential billing';
export const SUC_CAN_CRED_OFF = 'Successfully canceled credential offer';
export const SUC_DIST_CRED_BILL = 'Successfully distributed credential billing';
export const SUC_OFF_CRED_FREE = 'Successfully offered free credential';
export const SUC_OFF_CRED_PAID = 'Successfully offered paid credential';
export const SUC_REJ_CRED_OFF = 'Successfully rejected credential offer';
export const SUC_REV_CAN_CRED = 'Successfully revoked credential and canceled billing';
export const SUC_REV_CRED = 'Successfully revoked credential';
export const SUC_TOPUP_CRED_BILL = 'Successfully topped up deposit for credential billing';
export const SUC_FLUSH_EXPIRED_CRED_BILL =
  'Successfully flushed expired deposit for credential billing';
export const SUC_MOD_APP_REWARD_CONFIG = 'Successfully modified app reward configuration';
export const ERR_MOD_APP_REWARD_CONFIG = 'Failed to modify app reward configuration';
export const SUC_ARC_APP_REWARD_CONFIG = 'Successfully deleted app reward configuration';
export const ERR_ARC_APP_REWARD_CONFIG = 'Failed to delete app reward configuration';

// Credential operator mutations
export const ERR_ACC_USER_SVC = 'Failed to accept credential user service request';
export const ERR_CAN_USER_SVC = 'Failed to cancel credential user service request';
export const ERR_REJ_USER_SVC = 'Failed to reject credential user service request';
export const ERR_REQ_USER_SVC = 'Failed to request credential user service';
export const ERR_TER_USER_SVC = 'Failed to terminate credential user service';
export const SUC_ACC_USER_SVC = 'Successfully accepted credential user service request';
export const SUC_CAN_USER_SVC = 'Successfully canceled credential user service request';
export const SUC_REJ_USER_SVC = 'Successfully rejected credential user service request';
export const SUC_REQ_USER_SVC = 'Successfully requested credential user service';
export const SUC_TER_USER_SVC = 'Successfully terminated credential user service';

// Registry operator mutations
export const ERR_ACC_PROVIDER_SVC = 'Failed to accept registry provider service request';
export const ERR_ARC_OP_CONF = 'Failed to archive operator configuration';
export const ERR_CAN_PROVIDER_SVC = 'Failed to cancel registry provider service request';
export const ERR_CRE_OP_CONF = 'Failed to create operator configuration';
export const ERR_MOD_OP_CONF = 'Failed to modify operator configuration';
export const ERR_REJ_PROVIDER_SVC = 'Failed to reject registry provider service request';
export const ERR_REQ_PROVIDER_SVC = 'Failed to request registry provider service';
export const ERR_TER_PROVIDER_SVC = 'Failed to terminate registry provider service';
export const SUC_ACC_PROVIDER_SVC = 'Successfully accepted registry provider service request';
export const SUC_ARC_OP_CONF = 'Successfully archived operator configuration';
export const SUC_CAN_PROVIDER_SVC = 'Successfully canceled registry provider service request';
export const SUC_CRE_OP_CONF = 'Successfully created operator configuration';
export const SUC_MOD_OP_CONF = 'Successfully modified operator configuration';
export const SUC_REJ_PROVIDER_SVC = 'Successfully rejected registry provider service request';
export const SUC_REQ_PROVIDER_SVC = 'Successfully requested registry provider service';
export const SUC_TER_PROVIDER_SVC = 'Successfully terminated registry provider service';

// Registry provider mutations
export const ERR_ACC_REGISTRAR_SVC = 'Failed to accept registry registrar service request';
export const ERR_ARC_PROVIDER_CONF = 'Failed to archive provider configuration';
export const ERR_CAN_REGISTRAR_SVC = 'Failed to cancel registry registrar service request';
export const ERR_CRE_PROVIDER_CONF = 'Failed to create provider configuration';
export const ERR_MOD_PROVIDER_CONF = 'Failed to modify provider configuration';
export const ERR_REJ_REGISTRAR_SVC = 'Failed to reject registry registrar service request';
export const ERR_REQ_REGISTRAR_SVC = 'Failed to request registry registrar service';
export const ERR_TER_REGISTRAR_SVC = 'Failed to terminate registry registrar service';
export const SUC_ACC_REGISTRAR_SVC = 'Successfully accepted registry registrar service request';
export const SUC_ARC_PROVIDER_CONF = 'Successfully archived provider configuration';
export const SUC_CAN_REGISTRAR_SVC = 'Successfully canceled registry registrar service request';
export const SUC_CRE_PROVIDER_CONF = 'Successfully created provider configuration';
export const SUC_MOD_PROVIDER_CONF = 'Successfully modified provider configuration';
export const SUC_REJ_REGISTRAR_SVC = 'Successfully rejected registry registrar service request';
export const SUC_REQ_REGISTRAR_SVC = 'Successfully requested registry registrar service';
export const SUC_TER_REGISTRAR_SVC = 'Successfully terminated registry registrar service';
export const SUC_CREATE_DELEGATED_BATCHED_MARKERS_PROXY = 'Successfully delegated markers creation';
export const ERR_CREATE_DELEGATED_BATCHED_MARKERS_PROXY = 'Failed to delegate markers creation';

// Registry registrar mutations
export const ERR_ACC_BURN = 'Failed to accept burn request';
export const ERR_ACC_MINT = 'Failed to accept mint request';
export const ERR_ARC_INST_CONF = 'Failed to archive instrument configuration';
export const ERR_CRE_INST_CONF = 'Failed to create instrument configuration';
export const ERR_MOD_INST_CONF = 'Failed to modify instrument configuration';
export const ERR_REJ_BURN = 'Failed to reject burn request';
export const ERR_REJ_MINT = 'Failed to reject mint request';
export const SUC_ACC_BURN = 'Successfully accepted burn request';
export const SUC_ACC_MINT = 'Successfully accepted mint request';
export const SUC_ARC_INST_CONF = 'Successfully archived instrument configuration';
export const SUC_CRE_INST_CONF = 'Successfully created instrument configuration';
export const SUC_MOD_INST_CONF = 'Successfully modified instrument configuration';
export const SUC_REJ_BURN = 'Successfully rejected burn request';
export const SUC_REJ_MINT = 'Successfully rejected mint request';
export const SUC_CREATE_ALLOCATION_FACTORY = 'Successfully created allocation factory';
export const ERR_CREATE_ALLOCATION_FACTORY = 'Failed to create allocation factory';
export const SUC_CREATE_TRANSFER_RULE = 'Successfully created transfer rule';
export const ERR_CREATE_TRANSFER_RULE = 'Failed to create transfer rule';
export const SUC_WITHDRAW_ALLOCATION = 'Successfully withdrew allocatoin';
export const ERR_WITHDRAW_ALLOCATION = 'Failed to withdraw allocation';

// Registry holder mutations
export const ERR_CAN_BURN = 'Failed to cancel burn request';
export const ERR_CAN_MINT = 'Failed to cancel mint request';
export const ERR_REQ_BURN = 'Failed to request burn';
export const ERR_REQ_MINT = 'Failed to request mint';
export const SUC_INSTRUCT_XFER = 'Successfully instructed transfer';
export const ERR_INSTRUCT_XFER = 'Failed to instruct transfer';
export const SUC_ACC_INSTRUCT_XFER = 'Successfully accepted instructed transfer';
export const ERR_ACC_INSTRUCT_XFER = 'Failed to accept instructed transfer';
export const SUC_WITHDRAW_INSTRUCT_XFER = 'Successfully withdrew instructed transfer offer';
export const ERR_WITHDRRAW_INSTRUCT_XFER = 'Failed to withdraw instructed transfer offer';
export const SUC_REJECT_INSTRUCT_XFER = 'Successfully rejected instructed transfer';
export const ERR_REJECT_INSTRUCT_XFER = 'Failed to reject instructed transfer';
export const SUC_CAN_BURN = 'Successfully canceled burn request';
export const SUC_CAN_MINT = 'Successfully canceled mint request';
export const SUC_REQ_BURN = 'Successfully requested burn';
export const SUC_REQ_MINT = 'Successfully requested mint';
export const SUC_CREATE_APP_REWARD_CONFIG = 'Successfully created app reward configuration';
export const ERR_CREATE_APP_REWARD_CONFIG = 'Failed to create app reward configuration';
export const ERR_CREATE_PREAPPROVAL_SVC = 'Failed to create preapproval';
export const SUC_CREATE_PREAPPROVAL_SVC = 'Successfully created preapproval';
export const SUC_WITHDRAW_PREAPPROVAL = 'Successfully withdrew preapproval';
export const ERR_WITHDRAW_PREAPPROVAL = 'Failed to withdraw preapproval';
export const SUC_MOD_PREAPPROVAL = 'Successfully modified preapproval';
export const ERR_MOD_PREAPPROVAL = 'Failed to modify preapproval';

// Coin mutations
export const ERR_TAP_COIN = 'Failed to tap coin';
export const SUC_TAP_COIN = 'Successfully tapped coin';

// Collateral operator mutations
export const ERR_COL_ACC_PROVIDER_SVC = 'Failed to accept collateral provider service request';

// Collateral provider mutations
export const SUC_COL_REQ_USER_SVC = 'Successfully requested collateral user service';
export const SUC_COL_ACC_USER_SVC = 'Successfully accepted collateral user service request';
export const SUC_COL_REJ_USER_SVC = 'Successfully rejected collateral user service request';
export const SUC_COL_CAN_USER_SVC = 'Successfully canceled collateral user service request';
export const SUC_COL_TER_USER_SVC = 'Successfully terminated collateral user service';
export const ERR_COL_REQ_USER_SVC = 'Failed to request collateral user service';
export const ERR_COL_ACC_USER_SVC = 'Failed to accept collateral user service request';
export const ERR_COL_REJ_USER_SVC = 'Failed to reject collateral user service request';
export const ERR_COL_CAN_USER_SVC = 'Failed to cancel collateral user service request';
export const ERR_COL_TER_USER_SVC = 'Failed to terminate collateral user service';

// Collateral mutations
export const SUC_CAN_INST = 'Successfully cancelled instruction';
export const ERR_CAN_INST = 'Failed to cancel instruction';
export const SUC_REQ_AGR = 'Successfully requested collateral agreement';
export const SUC_ACC_AGR_REQ = 'Successfully accepted collateral agreement request';
export const SUC_REJ_AGR_REQ = 'Successfully rejected collateral agreement request';
export const SUC_CAN_AGR_REQ = 'Successfully canceled collateral agreement request';
export const ERR_REQ_AGR = 'Failed to request collateral agreement';
export const ERR_ACC_AGR_REQ = 'Failed to accept collateral agreement request';
export const ERR_REJ_AGR_REQ = 'Failed to reject collateral agreement request';
export const ERR_CAN_AGR_REQ = 'Failed to cancel collateral agreement request';
export const SUC_TERMINATE_COL_AGREEMENT = `Successfully terminated Collateral Agreement`;
export const ERR_TERMINATE_COL_AGREEMENT = `Failed to terminate collateral agreement`;
export const SUC_REQ_CHANGE = `Successfully create agreement change request`;
export const ERR_REQ_CHANGE = `Failed to create agreement change request`;
export const SUC_ACC_CHANGE_REQ = `Successfully accepted the collateral agreement change request`;
export const ERR_ACC_CHANGE_REQ = `Failed to accepted the collateal agreement change request`;
export const SUC_CAN_CHANGE_REQ = `Successfully cancelled change request`;
export const ERR_CAN_CHANGE_REQ = `Failed to cancel change request`;
export const SUC_REJ_CHANGE_REQ = `Successfully rejected change request`;
export const ERR_REJ_CHANGE_REQ = `Failed to rejected change request`;
export const SUC_OFFER_COL = `Successfully offered collateral`;
export const ERR_OFFER_COL = `Failed to offer collateral`;
export const SUC_SETTLE_COL = 'Successfully settled collateral';
export const ERR_SETTLE_COL = 'Failed to settle collateral';

// Commercial Agreement
export const SUC_CREATE_COMMERCIAL_AGREEMENT = 'Successfully created commercial agreement';
export const ERR_CREATE_COMMERCIAL_AGREEMENT = 'Failed to create commercial agreement';
export const SUC_CANCEL_COMMERCIAL_AGREEMENT = 'Successfully cancelled commercial agreement';
export const ERR_CANCEL_COMMERCIAL_AGREEMENT = 'Failed to cancel commercial agreement';
export const SUC_MODIFY_COMMERCIAL_AGREEMENT = 'Successfully modified commercial agreement';
export const ERR_MODIFY_COMMERCIAL_AGREEMENT = 'Failed to modify commercial agreement';
export const SUC_REJECT_COMMERCIAL_AGREEMENT = 'Successfully rejected commercial agreement';
export const ERR_REJECT_COMMERCIAL_AGREEMENT = 'Failed to reject commercial agreement';
export const SUC_ACCEPT_COMMERCIAL_AGREEMENT = 'Successfully accepted commercial agreement';
export const ERR_ACCEPT_COMMERCIAL_AGREEMENT = 'Failed to accept commercial agreement';
export const SUC_REVOKE_COMMERCIAL_AGREEMENT = 'Successfully revoked commercial agreement';
export const ERR_REVOKE_COMMERCIAL_AGREEMENT = 'Failed to revoke commercial agreement';
export const SUC_FLUSH_EXPIRED_COMMERCIAL_AGREEMENT =
  'Successfully flushed expired deposit for commercial agreement';
export const ERR_FLUSH_EXPIRED_COMMERCIAL_AGREEMENT =
  'Failed to flush expired deposit for commercial agreement';
export const SUC_TOPUP_COMMERCIAL_AGREEMENT = 'Successfully topped up';
export const ERR_TOPUP_COMMERCIAL_AGREEMENT = 'Failed to top up';

export const SUC_UPDATE_COMMERCIAL_AGREEMENT_CONSENT =
  'Successfully updated data publishing consent';
export const ERR_UPDATE_COMMERCIAL_AGREEMENT_CONSENT = 'Failed to update data publishing consent';

// Allocation Instruction
export const SUC_CREATE_ALLOCATION = 'Successfully created allocation';
export const ERR_CREATE_ALLOCATION = 'Failed to create allocation';
